import axios from 'axios';
import { req } from './axiosFun';

// 班级数据 列表
export const queryByPage = (params) => {
  return req("post", "/api/class/queryByPage", params)
};

// 班级数据 新增
export const savaClass = (params) => {
  return req("post", "/api/class/savaClass", params)
};

// 班级数据 修改
export const updateClass = (params) => {
  return req("post", "/api/class/updateClass", params)
};

// 班级数据 删除
export const deleteClass = (params) => {
  return req("post", "/api/class/deleteClass", params)
};

// 班级数据 详情
export const queryClassDetail = (params) => {
  return req("post", "/api/class/queryClassDetail", params)
};

// 班级数据  获取二维码
export const generateQRCode = (params) => {
  return req("post", "/api/class/generateQRCode", params)
};

// 班级数据 详情
export const queryClassHeadInfo = (id) => {
  return req("get", "/api/class/queryClassHeadInfo?bjbId=" + id, '')
};




// 班级id查询学员列表
export const queryStudentByClassId = (params) => {
  return req("post", "/api/class/queryStudentByClassId", params)
};

// 换班 查询班组列表
export const changeClassList = (params) => {
  return req("post", "/api/class/changeClassList", params)
};



// WEBPACK FOOTER //
// ./src/api/classInfo.js